'use client';

import { LogoIcon, LogoTextIcon } from '@/components/icons';
import { VRNFEST_MOLWE_HOME_URL } from '@/features/vrnfest/constants';

export function VrnfestHeader() {
  return (
    <div className="flex w-full items-center justify-between gap-4">
      <a
        href={VRNFEST_MOLWE_HOME_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-shrink-0 items-center gap-1"
      >
        <LogoIcon className="flex h-8.5 w-8 items-center justify-center rounded-md bg-[#25282e]" />
        <LogoTextIcon className="h-fit w-fit pb-2 text-2xl font-bold text-white" />
      </a>
      <p className="roboto-flex-compressed min-w-0 text-white text-[18px] leading-[90%] tracking-normal uppercase text-right lg:text-[24px] lg:leading-[90%] lg:text-center">
        VRNFEST · конкурс 2026
      </p>
    </div>
  );
}
